import { render, staticRenderFns } from "./VoteSimple.vue?vue&type=template&id=3d6d51f7&scoped=true"
import script from "./VoteSimple.vue?vue&type=script&lang=js"
export * from "./VoteSimple.vue?vue&type=script&lang=js"
import style0 from "./VoteSimple.vue?vue&type=style&index=0&id=3d6d51f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6d51f7",
  null
  
)

export default component.exports